import _dayjs, { Dayjs } from 'dayjs';
import duration from 'dayjs/plugin/duration';
import relativeTime from 'dayjs/plugin/relativeTime';
import utc from 'dayjs/plugin/utc';

_dayjs.extend(relativeTime);
_dayjs.extend(duration);
_dayjs.extend(utc);
const dayjs = _dayjs.utc;

export default dayjs;
export { Dayjs, _dayjs };
